import './set-public-path';
import './i18n';
import { captureAttributionFromUrl } from './utils/attribution';
import { cargarGoogleTag } from './utils/googleTag';
import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// --- DESACTIVAR SERVICE WORKER POR COMPLETO ---
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Atribución de campaña: se lee ANTES de montar React y antes de que el router
// evalúe nada. Un visitante sin sesión que llega a /contratar?utm_source=… es
// redirigido a `/` sin conservar el querystring, así que si no se lee acá, se
// pierde. Ver utils/attribution.js.
//
// Va después de los imports por `import/first` (CRA trata ese lint como error de
// build). No cambia el orden de ejecución: los imports de ES se evalúan antes
// que cualquier sentencia del módulo, esté donde esté la llamada.
captureAttributionFromUrl();

// Google tag (GA4): apagado mientras `GA4_MEASUREMENT_ID` sea nulo; con ID, los defaults de
// Consent Mode van a `dataLayer` antes de que cargue el script. Ver utils/googleTag.js.
cargarGoogleTag();

// Guardar fetch nativo antes de que terceros lo reemplacen
if (!window.__nativeFetch) {
  window.__nativeFetch = window.fetch?.bind(window);
}
// Fijarlo para el resto de la app
if (window.__nativeFetch) {
  window.fetch = window.__nativeFetch;
}

function Root() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showReload, setShowReload] = useState(false);

  const onUpdate = (registration) => {
    setWaitingWorker(registration.waiting);
    setShowReload(true);
  };

  const reloadPage = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    setShowReload(false);
    window.location.reload();
  };

  // 🔍 Detector de pantalla en blanco (fix Service Worker cache)
  React.useEffect(() => {
    const timer = setTimeout(() => {
      const appElement = document.getElementById('root');
      if (appElement && (!appElement.innerHTML || appElement.innerHTML.trim() === '')) {
        console.log('🚨 Pantalla en blanco detectada - Limpiando cache y recargando...');
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(registrations => {
            const promises = registrations.map(reg => reg.unregister());
            Promise.all(promises).then(() => {
              if ('caches' in window) {
                caches.keys().then(names => {
                  const deletePromises = names.map(name => caches.delete(name));
                  Promise.all(deletePromises).then(() => {
                    window.location.reload(true);
                  });
                });
              } else {
                window.location.reload(true);
              }
            });
          });
        } else {
          window.location.reload(true);
        }
      }
    }, 3000); // Esperar 3 segundos antes de verificar

    return () => clearTimeout(timer);
  }, []);

  return (
    <React.StrictMode>
      <App />
      {showReload && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#1a73e8',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            zIndex: 9999
          }}
          onClick={reloadPage}
        >
          🔄 Nueva versión disponible - Actualizar
        </div>
      )}
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();

// Register the kill-switch service worker. It evicts any stale workbox SW and clears
// caches (in its activate handler), then unregisters itself. The previous page-side
// manual unregister/caches.delete loop was removed — it was the fragile approach that
// never reliably evicted the old SW (and would now fight the register() below).
serviceWorkerRegistration.register();